import { render, staticRenderFns } from "./iButtonList.vue?vue&type=template&id=b1a8293c&scoped=true"
import script from "./iButtonList.vue?vue&type=script&lang=js"
export * from "./iButtonList.vue?vue&type=script&lang=js"
import style0 from "./iButtonList.vue?vue&type=style&index=0&id=b1a8293c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a8293c",
  null
  
)

export default component.exports